import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CustomIconButton from './IconButton'

type SizeButton = 'small' | 'medium' | 'large'

const GoBackButton = ({
    navigate,
    size = 'medium',
}: {
    navigate: () => void
    size?: SizeButton
}) => {
    return (
        <CustomIconButton
            className="bg-white text-secondary rounded-[5px] shadow hover:bg-primary hover:text-white"
            icon={<ArrowBackIcon />}
            onClick={navigate}
            size={size}
        />
    )
}

export default GoBackButton
